<template>

  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Copy Price List</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>

      <v-card-text>
        <v-form ref="priceListForm">
          <v-row dense>
            <v-col cols="4">
              <v-autocomplete outlined dense v-model="record.FromPricelist" :items="priceLists"
                item-text="Name" item-value="id" label="From Price List"></v-autocomplete>
            </v-col>

            <v-col cols="4">
              <v-autocomplete outlined dense v-model="record.ToPricelist" :items="priceLists"
                item-text="Name" item-value="id" label="To price List"></v-autocomplete>
            </v-col>


            <v-col cols="12">
              <v-btn color="accent" @click="sendData" :loading="loader">
                <v-icon left>mdi-content-save</v-icon> Copy Price List
              </v-btn>
            </v-col>
          </v-row>

          <snackbar ref="snackbar"></snackbar>
        </v-form>
      </v-card-text>
    </v-card>
  </v-container>

</template>


<script>
export default {
  props: {
    initial: {
      type: Object,
      required: true
    },
    docCreate: {
      type: Boolean
    }
  },
  data: () => ({
    record: {},
    priceLists : [],
    valid: false,
    lazy: false,
    inputRules: [v => !!v || "Required"],
    showOnProductEdit: true,
    discountPercent: 0,
    existing: true,
    loader: false,
    date: new Date().toISOString().substr(0, 10)
  }),
  watch: {
    initial: {
      handler: "init",
      immediate: true
    }
  },
  methods: {
    init(val) {
      this.showOnProductEdit = val.showOnProductEdit == 1 ? true : false;
      this.discountPercent = val.discountPercent;
      this.record = { ...val };
    },
    setDate(date) {
      this.record.date = date;
    },
    sendData() {
      const url = "/copy-price-list";
      const self = this;
      const data = this.record;
      this.loader = true;
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.$refs.snackbar.show("Prices copied successfully", "green");
            location.reload();
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getData() {
      const self = this;
      this.$store
        .dispatch("get", `/price-list`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.priceLists = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    }
  },
  created() { 
    this.getData();
  }
};
</script>